import {FC, useEffect} from 'react'
import {Modal, Button} from 'react-bootstrap'
import {AgreementChapter} from '../../trade-data-agreement-chapter/core/_models'

interface ModalArticleTextProps {
  show: boolean
  onHide: () => void
  chapter: AgreementChapter | null
  position?: number
  total?: number
  onPrev?: () => void
  onNext?: () => void
  hasPrev?: boolean
  hasNext?: boolean
}

const ModalArticleText: FC<ModalArticleTextProps> = ({
  show,
  onHide,
  chapter,
  position,
  total,
  onPrev,
  onNext,
  hasPrev = false,
  hasNext = false,
}) => {
  const heading = [chapter?.article_number, chapter?.article_name].filter(Boolean).join('. ')
  const chapterHeading = [chapter?.chapter_number, chapter?.chapter_name]
    .filter(Boolean)
    .join('. ')

  useEffect(() => {
    if (!show) return

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowLeft' && hasPrev) onPrev?.()
      if (event.key === 'ArrowRight' && hasNext) onNext?.()
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [show, hasPrev, hasNext, onPrev, onNext])

  return (
    <Modal show={show} onHide={onHide} size='xl' centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className='fs-4'>{heading || 'Article text'}</div>
          {chapterHeading && <div className='fs-7 text-muted mt-1'>{chapterHeading}</div>}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {chapter?.article_text_display ? (
          <div
            className='article-text-preview'
            dangerouslySetInnerHTML={{__html: chapter.article_text_display}}
          />
        ) : (
          <div className='text-muted text-center py-5'>This article has no text.</div>
        )}
      </Modal.Body>

      <Modal.Footer className='justify-content-between'>
        <span className='text-muted fs-8'>
          {chapter?.article_id} · {chapter?.nwords_new ?? 0} words
          {position && total ? ` · ${position} of ${total}` : ''}
        </span>

        <div className='d-flex gap-2'>
          <Button variant='outline-primary' onClick={onPrev} disabled={!hasPrev}>
            <span className='fa fa-chevron-left me-2'></span>
            Previous
          </Button>
          <Button variant='outline-primary' onClick={onNext} disabled={!hasNext}>
            Next
            <span className='fa fa-chevron-right ms-2'></span>
          </Button>
          <Button variant='default' className='btn-cancel' onClick={onHide}>
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalArticleText
